import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container px-0" }
const _hoisted_2 = { class: "container-fluid py-3 page-main-title" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col text-center page-main-title" }
const _hoisted_5 = { class: "white-text" }
const _hoisted_6 = { class: "col-md-9 col-lg-10 px-md-4" }
const _hoisted_7 = { class: "container py-3" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-6 py-3" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12 text-center text-lg-start py-3" }
const _hoisted_12 = { class: "hc1 bold" }
const _hoisted_13 = { class: "col-12 p-4 bg-grey" }
const _hoisted_14 = { class: "grey-text" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "grey-text" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-12 pt-4 pb-2" }
const _hoisted_19 = { class: "grey-text" }
const _hoisted_20 = { class: "row mb-2" }
const _hoisted_21 = {
  key: 0,
  class: "row bg-grey custom_margin"
}
const _hoisted_22 = { class: "col-12 p-4" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "col-12 p-4" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "col-12 p-4" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "col-12 p-4" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "col-12 p-4" }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = ["src"]
const _hoisted_37 = {
  key: 1,
  class: "row custom_margin"
}
const _hoisted_38 = {
  class: "tut-accordion",
  id: "tutorial"
}
const _hoisted_39 = { class: "tut-box" }
const _hoisted_40 = { class: "" }
const _hoisted_41 = { class: "bold hc3" }
const _hoisted_42 = { class: "hc7 tut-small-border" }
const _hoisted_43 = { class: "hc8" }
const _hoisted_44 = {
  key: 0,
  class: "tut-button"
}
const _hoisted_45 = { class: "hc7" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid image-border",
  src: "/images/tutorials/ios/down.svg"
}, null, -1)
const _hoisted_47 = {
  class: "collapse tut-accordion-desc flex-column",
  id: "part1",
  "data-bs-parent": "#tutorial"
}
const _hoisted_48 = { class: "container" }
const _hoisted_49 = { class: "row bg-grey" }
const _hoisted_50 = { class: "col-12 p-4" }
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = ["src"]
const _hoisted_53 = { class: "col-12 p-4" }
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = ["src"]
const _hoisted_56 = ["src"]
const _hoisted_57 = { class: "col-12 p-4" }
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = ["src"]
const _hoisted_60 = { class: "col-12 p-4" }
const _hoisted_61 = ["innerHTML"]
const _hoisted_62 = ["src"]
const _hoisted_63 = { class: "col-12 p-4" }
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = ["src"]
const _hoisted_66 = { class: "col-12 p-4" }
const _hoisted_67 = ["innerHTML"]
const _hoisted_68 = ["src"]
const _hoisted_69 = { class: "col-12 p-4" }
const _hoisted_70 = ["innerHTML"]
const _hoisted_71 = ["src"]
const _hoisted_72 = { class: "col-12 p-4 tutorial-relative-container" }
const _hoisted_73 = { class: "tut-button" }
const _hoisted_74 = {
  key: 0,
  class: "hc7"
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid image-border",
  src: "/images/tutorials/ios/up.svg"
}, null, -1)
const _hoisted_76 = { class: "tut-box" }
const _hoisted_77 = { class: "" }
const _hoisted_78 = { class: "bold hc3" }
const _hoisted_79 = { class: "hc8" }
const _hoisted_80 = {
  key: 0,
  class: "tut-button"
}
const _hoisted_81 = { class: "hc7" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid image-border",
  src: "/images/tutorials/ios/down.svg"
}, null, -1)
const _hoisted_83 = {
  class: "collapse tut-accordion-desc flex-column",
  id: "part2",
  "data-bs-parent": "#tutorial"
}
const _hoisted_84 = { class: "container" }
const _hoisted_85 = { class: "row bg-grey" }
const _hoisted_86 = { class: "col-12 p-4 text-center" }
const _hoisted_87 = {
  class: "btn-tutorial-apple bold",
  href: "https://support.apple.com/zh-cn/118283",
  target: "_blank"
}
const _hoisted_88 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid image-border",
  src: "/images/tutorials/ios/apple.svg",
  alt: "ios_tutorial"
}, null, -1)
const _hoisted_89 = { class: "col-12 p-4 tutorial-relative-container" }
const _hoisted_90 = { class: "tut-button" }
const _hoisted_91 = {
  key: 0,
  class: "hc7"
}
const _hoisted_92 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid image-border",
  src: "/images/tutorials/ios/up.svg"
}, null, -1)
const _hoisted_93 = { class: "tut-box" }
const _hoisted_94 = { class: "" }
const _hoisted_95 = { class: "bold hc3" }
const _hoisted_96 = { class: "hc8" }
const _hoisted_97 = {
  key: 0,
  class: "tut-button"
}
const _hoisted_98 = { class: "hc7" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid image-border",
  src: "/images/tutorials/ios/down.svg"
}, null, -1)
const _hoisted_100 = {
  class: "collapse tut-accordion-desc flex-column",
  id: "part3",
  "data-bs-parent": "#tutorial"
}
const _hoisted_101 = { class: "container" }
const _hoisted_102 = { class: "row bg-grey" }
const _hoisted_103 = { class: "col-12 p-4 text-center" }
const _hoisted_104 = {
  class: "btn-tutorial-apple bold vertical-align-middle",
  href: "/support",
  target: "_blank"
}
const _hoisted_105 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid image-border",
  src: "/images/tutorials/ios/chat_white.svg",
  alt: "ios_tutorial"
}, null, -1)
const _hoisted_106 = { class: "col-12 p-4 tutorial-relative-container" }
const _hoisted_107 = { class: "tut-button" }
const _hoisted_108 = {
  key: 0,
  class: "hc7"
}
const _hoisted_109 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid image-border",
  src: "/images/tutorials/ios/up.svg"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString($setup.locale.ios10), 1)
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Breadcrumb, {
              class: "grey-text",
              item_one_title: $setup.locale.ios11,
              item_one_active: true,
              loading: $setup.data.loading
            }, null, 8, ["item_one_title", "loading"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString($setup.locale.ios11), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString($setup.locale.ios12), 1),
            _hoisted_15,
            _createElementVNode("span", _hoisted_16, _toDisplayString($setup.locale.ios13), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("span", _hoisted_19, _toDisplayString($setup.locale.ios14), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", {
            onMouseover: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleMouseOver && $setup.handleMouseOver(...args))),
            onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleMouseLeave && $setup.handleMouseLeave(...args))),
            class: _normalizeClass($setup.data.page == 1 /* && !data.hover */? 'col ios-tab text-center  btn-selected  bg-grey' : 'col ios-tab text-center   bg-grey')
          }, [
            _createElementVNode("a", {
              class: _normalizeClass(($setup.data.page == 1 /* && !data.hover */? 'btn-selected' : '') + ' vertical-align-middle'),
              href: "/tutorials/ios?page=1&p=2"
            }, _toDisplayString($setup.locale.ios15), 3)
          ], 34),
          _createElementVNode("div", {
            onMouseover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.handleMouseOver && $setup.handleMouseOver(...args))),
            onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.handleMouseLeave && $setup.handleMouseLeave(...args))),
            class: _normalizeClass($setup.data.page == 2 /* && !data.hover */? 'col ios-tab text-center  btn-selected  bg-grey' : 'col ios-tab text-center   bg-grey')
          }, [
            _createElementVNode("a", {
              class: _normalizeClass(($setup.data.page == 2 /* && !data.hover */? 'btn-selected' : '') + ' vertical-align-middle'),
              href: "/tutorials/ios?page=2&p=2"
            }, _toDisplayString($setup.locale.ios16), 3)
          ], 34)
        ]),
        ($setup.data.page == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("span", {
                  innerHTML: $setup.locale.ios17
                }, null, 8, _hoisted_23),
                _createElementVNode("img", {
                  class: "img-fluid image-border",
                  src: $setup.data.images[0],
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[0]))),
                  alt: "ios_tutorial"
                }, null, 8, _hoisted_24)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("span", {
                  innerHTML: $setup.locale.ios18
                }, null, 8, _hoisted_26),
                _createElementVNode("img", {
                  class: "img-fluid image-border",
                  src: $setup.data.images[1],
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[1]))),
                  alt: "ios_tutorial"
                }, null, 8, _hoisted_27)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("span", {
                  innerHTML: $setup.locale.ios19
                }, null, 8, _hoisted_29),
                _createElementVNode("img", {
                  class: "img-fluid image-border",
                  src: $setup.data.images[2],
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[2]))),
                  alt: "ios_tutorial"
                }, null, 8, _hoisted_30)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("span", {
                  innerHTML: $setup.locale.ios20
                }, null, 8, _hoisted_32),
                _createElementVNode("img", {
                  class: "img-fluid image-border",
                  src: $setup.data.images[3],
                  onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[3]))),
                  alt: "ios_tutorial"
                }, null, 8, _hoisted_33)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("span", {
                  innerHTML: $setup.locale.ios21
                }, null, 8, _hoisted_35),
                _createElementVNode("img", {
                  class: "img-fluid image-border",
                  src: $setup.data.images[4],
                  id: "auto-download-ios-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.openURL('https://apps.apple.com/hk/app/id6670307607'))),
                  alt: "ios_tutorial"
                }, null, 8, _hoisted_36)
              ])
            ]))
          : _createCommentVNode("", true),
        ($setup.data.page == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createElementVNode("ul", _hoisted_38, [
                _createElementVNode("li", _hoisted_39, [
                  _createElementVNode("a", {
                    href: "#part1",
                    class: "px-0 align-middle",
                    "data-bs-toggle": "collapse",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.toggleCollapse(1)))
                  }, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("span", _hoisted_41, [
                        _createTextVNode(_toDisplayString($setup.locale.ios22) + " ", 1),
                        _createElementVNode("span", _hoisted_42, _toDisplayString($setup.locale.ios23), 1)
                      ]),
                      _createElementVNode("p", _hoisted_43, _toDisplayString($setup.locale.ios24), 1),
                      (!$setup.data.isCollapsed1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _createElementVNode("span", _hoisted_45, [
                              _createTextVNode(_toDisplayString($setup.locale.ios25) + " ", 1),
                              _hoisted_46
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("span", {
                          innerHTML: $setup.locale.ios30
                        }, null, 8, _hoisted_51),
                        _createElementVNode("img", {
                          class: "img-fluid image-border",
                          src: $setup.data.images[5],
                          onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[5]))),
                          alt: "ios_tutorial"
                        }, null, 8, _hoisted_52)
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("span", {
                          innerHTML: $setup.locale.ios31
                        }, null, 8, _hoisted_54),
                        _createElementVNode("img", {
                          class: "img-fluid image-border",
                          src: $setup.data.images[6],
                          onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[6]))),
                          alt: "ios_tutorial"
                        }, null, 8, _hoisted_55),
                        _createElementVNode("img", {
                          class: "img-fluid image-border",
                          src: $setup.data.images[7],
                          onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[7]))),
                          alt: "ios_tutorial"
                        }, null, 8, _hoisted_56)
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("span", {
                          innerHTML: $setup.locale.ios32
                        }, null, 8, _hoisted_58),
                        _createElementVNode("img", {
                          class: "img-fluid image-border",
                          src: $setup.data.images[8],
                          onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[8]))),
                          alt: "ios_tutorial"
                        }, null, 8, _hoisted_59)
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("span", {
                          innerHTML: $setup.locale.ios33
                        }, null, 8, _hoisted_61),
                        _createElementVNode("img", {
                          class: "img-fluid image-border",
                          src: $setup.data.images[9],
                          onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[9]))),
                          alt: "ios_tutorial"
                        }, null, 8, _hoisted_62)
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("span", {
                          innerHTML: $setup.locale.ios34
                        }, null, 8, _hoisted_64),
                        _createElementVNode("img", {
                          class: "img-fluid image-border",
                          src: $setup.data.images[10],
                          onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[10]))),
                          alt: "ios_tutorial"
                        }, null, 8, _hoisted_65)
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("span", {
                          innerHTML: $setup.locale.ios35
                        }, null, 8, _hoisted_67),
                        _createElementVNode("img", {
                          class: "img-fluid image-border",
                          src: $setup.data.images[11],
                          onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[11]))),
                          alt: "ios_tutorial"
                        }, null, 8, _hoisted_68)
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("span", {
                          innerHTML: $setup.locale.ios36
                        }, null, 8, _hoisted_70),
                        _createElementVNode("img", {
                          class: "img-fluid image-border",
                          src: $setup.data.images[12],
                          onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[12]))),
                          alt: "ios_tutorial"
                        }, null, 8, _hoisted_71)
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("a", {
                          href: "#part1",
                          class: "px-0 align-middle black-text",
                          "data-bs-toggle": "collapse",
                          onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.toggleCollapse(1)))
                        }, [
                          _createElementVNode("div", _hoisted_73, [
                            ($setup.data.isCollapsed1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_74, [
                                  _createTextVNode(_toDisplayString($setup.locale.ios25up) + " ", 1),
                                  _hoisted_75
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("li", _hoisted_76, [
                  _createElementVNode("a", {
                    href: "#part2",
                    class: "px-0 align-middle",
                    "data-bs-toggle": "collapse",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.toggleCollapse(2)))
                  }, [
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("span", _hoisted_78, _toDisplayString($setup.locale.ios26), 1),
                      _createElementVNode("p", _hoisted_79, _toDisplayString($setup.locale.ios27), 1),
                      (!$setup.data.isCollapsed2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                            _createElementVNode("span", _hoisted_81, [
                              _createTextVNode(_toDisplayString($setup.locale.ios25) + " ", 1),
                              _hoisted_82
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("a", _hoisted_87, [
                          _createElementVNode("span", null, [
                            _hoisted_88,
                            _createTextVNode(" " + _toDisplayString($setup.locale.ios37), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("a", {
                          href: "#part2",
                          class: "px-0 align-middle black-text",
                          "data-bs-toggle": "collapse",
                          onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.toggleCollapse(2)))
                        }, [
                          _createElementVNode("div", _hoisted_90, [
                            ($setup.data.isCollapsed2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_91, [
                                  _createTextVNode(_toDisplayString($setup.locale.ios25up) + " ", 1),
                                  _hoisted_92
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("li", _hoisted_93, [
                  _createElementVNode("a", {
                    href: "#part3",
                    class: "px-0 align-middle",
                    "data-bs-toggle": "collapse",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.toggleCollapse(3)))
                  }, [
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("span", _hoisted_95, _toDisplayString($setup.locale.ios28), 1),
                      _createElementVNode("p", _hoisted_96, _toDisplayString($setup.locale.ios29), 1),
                      (!$setup.data.isCollapsed3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                            _createElementVNode("span", _hoisted_98, [
                              _createTextVNode(_toDisplayString($setup.locale.ios25) + " ", 1),
                              _hoisted_99
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("div", _hoisted_102, [
                      _createElementVNode("div", _hoisted_103, [
                        _createElementVNode("a", _hoisted_104, [
                          _createElementVNode("span", null, [
                            _hoisted_105,
                            _createTextVNode(" " + _toDisplayString($setup.locale.ios38), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_106, [
                        _createElementVNode("a", {
                          href: "#part3",
                          class: "px-0 align-middle black-text",
                          "data-bs-toggle": "collapse",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => ($setup.toggleCollapse(3)))
                        }, [
                          _createElementVNode("div", _hoisted_107, [
                            ($setup.data.isCollapsed3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_108, [
                                  _createTextVNode(_toDisplayString($setup.locale.ios25up) + " ", 1),
                                  _hoisted_109
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}